<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Kullanıcı Yetki Yönetimi</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="topluDialogAc">
        <v-icon left>library_add</v-icon>Toplu Yetki Ver
      </v-btn>
    </v-toolbar>

    <v-card class="mb-3 pa-2">
      <v-layout align-center wrap>
        <v-flex xs12 sm6 class="px-2">
          <v-text-field v-model="arama" append-icon="search" label="Kullanıcı ara"
            single-line hide-details clearable></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="px-2">
          <v-checkbox v-model="yetkisizleriGizle" label="Yetkisizleri gizle"
            hide-details color="primary"></v-checkbox>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card>
      <div v-if="loading" class="yt-durum">Yükleniyor…</div>
      <div v-else-if="gosterilenler.length === 0" class="yt-durum">
        Eşleşen kullanıcı yok.
      </div>
      <div v-else>
        <div v-for="kullanici in gosterilenler" :key="kullanici.id" class="yt-satir">
          <div class="yt-ust">
            <span class="yt-ad">{{ kullanici.username }}</span>
            <span class="yt-tam">{{ kullanici.firstName }} {{ kullanici.lastName }}</span>
            <v-spacer></v-spacer>
            <span class="yt-sayi" :class="{ 'yt-sifir': yetkiSayisi(kullanici.id) === 0 }">
              {{ yetkiSayisi(kullanici.id) === 0 ? 'yetkisiz' : yetkiSayisi(kullanici.id) + ' yetki' }}
            </span>
            <v-btn small flat icon color="primary" @click="duzenle(kullanici)" title="Yetkileri düzenle">
              <v-icon small>edit</v-icon>
            </v-btn>
          </div>
          <div class="yt-alt">
            <div v-for="tenant in doluTenantlar(kullanici.id)" :key="tenant.id" class="yt-tenant">
              <span class="yt-tenant-ad">{{ tenant.name }}</span>
              <span v-for="ad in tenant.yetkiler" :key="ad" class="yt-rozet">{{ ad }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <v-dialog v-model="duzenleDialog" max-width="560px" persistent>
      <v-card v-if="duzenlenen">
        <v-card-title>
          <span class="headline">{{ duzenlenen.username }}</span>
          <span class="yt-tam ml-2">{{ duzenlenen.firstName }} {{ duzenlenen.lastName }}</span>
        </v-card-title>
        <v-card-text>
          <div v-for="tenant in tenantOptions" :key="tenant.id" class="yt-grup">
            <div class="yt-grup-ust">
              <span class="yt-grup-ad">{{ tenant.name }}</span>
              <v-btn small flat class="yt-hepsi" @click="tenantTumunu(tenant.id)">
                {{ tenantHepsiSecili(tenant.id) ? 'Hiçbiri' : 'Tümü' }}
              </v-btn>
            </div>
            <div class="yt-kutular">
              <label v-for="mp in marketPlaceOptions" :key="mp.id" class="yt-kutu">
                <input type="checkbox" v-model="secim[tenant.id][mp.id]" />
                <span>{{ mp.name }}</span>
              </label>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <span class="yt-ozet-kucuk">{{ secimSayisi }} yetki seçili</span>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="duzenleDialog = false">İptal</v-btn>
          <v-btn color="primary" :loading="saving" @click="kaydet">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="topluDialog" max-width="620px" persistent>
      <v-card>
        <v-card-title><span class="headline">Toplu Yetki Ver</span></v-card-title>
        <v-card-text>
          <v-select v-model="topluKullanicilar" :items="siraliKullanicilar" item-text="displayName"
            item-value="id" label="Kullanıcılar" multiple chips deletable-chips></v-select>
          <v-select v-model="topluTenantlar" :items="tenantOptions" item-text="name" item-value="id"
            label="Tenantlar" multiple chips deletable-chips></v-select>
          <v-select v-model="topluPazaryerleri" :items="marketPlaceOptions" item-text="name"
            item-value="id" label="Pazaryerleri" multiple chips deletable-chips></v-select>

          <div class="yt-ozet" v-if="topluToplam > 0">
            <strong>{{ topluYeni }}</strong> yetki verilecek
            <span v-if="topluMevcut > 0">· {{ topluMevcut }} tanesi zaten var, atlanacak</span>
          </div>
          <div class="yt-ozet yt-ozet-bos" v-else>Üç alandan da en az bir seçim yap.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="topluDialog = false">İptal</v-btn>
          <v-btn color="primary" :disabled="topluYeni === 0" :loading="saving" @click="topluKaydet">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userTenants: [],
      users: [],
      loading: false,
      saving: false,
      arama: "",
      yetkisizleriGizle: true,
      duzenleDialog: false,
      duzenlenen: null,
      secim: {},
      topluDialog: false,
      topluKullanicilar: [],
      topluTenantlar: [],
      topluPazaryerleri: [],
      tenantOptions: [
        { id: 1, name: "AltındaFirsat" },
        { id: 2, name: "EAltin" }
      ],
      marketPlaceOptions: []
    };
  },
  async created() {
    await this.loadMarketplaces();
    await this.loadUsers();
    await this.loadUserTenants();
  },
  computed: {
    siraliKullanicilar() {
      return this.users.slice().sort((a, b) => a.username.localeCompare(b.username, "tr"));
    },
    gosterilenler() {
      const q = (this.arama || "").toLocaleLowerCase("tr");
      return this.siraliKullanicilar.filter((u) => {
        if (this.yetkisizleriGizle && this.yetkiSayisi(u.id) === 0) return false;
        if (!q) return true;
        return (u.displayName || u.username).toLocaleLowerCase("tr").indexOf(q) > -1;
      });
    },
    secimSayisi() {
      let sayi = 0;
      this.tenantOptions.forEach((t) => {
        this.marketPlaceOptions.forEach((m) => {
          if (this.secim[t.id] && this.secim[t.id][m.id]) sayi++;
        });
      });
      return sayi;
    },
    topluToplam() {
      return this.topluKullanicilar.length * this.topluTenantlar.length * this.topluPazaryerleri.length;
    },
    topluMevcut() {
      let sayi = 0;
      this.topluKullanicilar.forEach((u) => {
        this.topluTenantlar.forEach((t) => {
          this.topluPazaryerleri.forEach((m) => {
            if (this.userTenants.some((k) => k.userId === u && k.tenantId === t && k.mpId === m)) sayi++;
          });
        });
      });
      return sayi;
    },
    topluYeni() {
      return this.topluToplam - this.topluMevcut;
    }
  },
  methods: {
    yetkiBasligi() {
      return { Authorization: `Bearer ${JSON.parse(localStorage.getItem("currentUser")).token}` };
    },
    bildir(mesaj) {
      this.$store.commit("SET_MESSAGE", mesaj);
      this.$store.commit("SET_DIALOG", true);
    },
    yetkiSayisi(userId) {
      return this.userTenants.filter((k) => k.userId === userId).length;
    },
    doluTenantlar(userId) {
      return this.tenantOptions
        .map((t) => ({ id: t.id, name: t.name, yetkiler: this.yetkiListesi(userId, t.id) }))
        .filter((t) => t.yetkiler.length > 0);
    },
    yetkiListesi(userId, tenantId) {
      return this.userTenants
        .filter((k) => k.userId === userId && k.tenantId === tenantId)
        .map((k) => this.getMarketPlaceName(k.mpId))
        .sort((a, b) => a.localeCompare(b, "tr"));
    },
    getMarketPlaceName(mpId) {
      const mp = this.marketPlaceOptions.find((m) => m.id === mpId);
      return mp ? mp.name : "Bilinmeyen";
    },
    async loadUserTenants() {
      this.loading = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_API}/api/usertenants`, {
          headers: this.yetkiBasligi()
        });
        this.userTenants = await response.json();
      } catch (error) {
        this.bildir("Yetkiler yüklenirken hata oluştu");
      } finally {
        this.loading = false;
      }
    },
    async loadUsers() {
      try {
        const response = await fetch(`${process.env.VUE_APP_API}/api/users`, {
          headers: this.yetkiBasligi()
        });
        const users = await response.json();
        this.users = users.map((user) => ({
          ...user,
          displayName: `${user.firstName} ${user.lastName} (${user.username})`
        }));
      } catch (error) {
        this.bildir("Kullanıcılar yüklenirken hata oluştu");
      }
    },
    async loadMarketplaces() {
      try {
        const response = await fetch(`${process.env.VUE_APP_API}/api/users/marketplaces`, {
          headers: this.yetkiBasligi()
        });
        this.marketPlaceOptions = await response.json();
      } catch (error) {
        this.marketPlaceOptions = [
          { id: 1, name: "Hepsiburada" },
          { id: 2, name: "Alışgidiş" },
          { id: 3, name: "Trendyol" },
          { id: 4, name: "Idefix" },
          { id: 5, name: "Idia" },
          { id: 6, name: "n11" }
        ];
      }
    },
    duzenle(kullanici) {
      const secim = {};
      this.tenantOptions.forEach((t) => {
        secim[t.id] = {};
        this.marketPlaceOptions.forEach((m) => {
          secim[t.id][m.id] = this.userTenants.some(
            (k) => k.userId === kullanici.id && k.tenantId === t.id && k.mpId === m.id
          );
        });
      });
      this.secim = secim;
      this.duzenlenen = kullanici;
      this.duzenleDialog = true;
    },
    tenantHepsiSecili(tenantId) {
      return this.marketPlaceOptions.every((m) => this.secim[tenantId][m.id]);
    },
    tenantTumunu(tenantId) {
      const hedef = !this.tenantHepsiSecili(tenantId);
      this.marketPlaceOptions.forEach((m) => {
        this.secim[tenantId][m.id] = hedef;
      });
    },
    async kaydet() {
      this.saving = true;
      try {
        const yetkiler = [];
        this.tenantOptions.forEach((t) => {
          this.marketPlaceOptions.forEach((m) => {
            if (this.secim[t.id][m.id]) yetkiler.push({ tenantId: t.id, mpId: m.id });
          });
        });

        const response = await fetch(
          `${process.env.VUE_APP_API}/api/usertenants/kullanici/${this.duzenlenen.id}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json", ...this.yetkiBasligi() },
            body: JSON.stringify({ yetkiler })
          }
        );
        if (!response.ok) {
          this.bildir("Yetkiler kaydedilirken hata oluştu");
          return;
        }
        const sonuc = await response.json();
        this.duzenleDialog = false;
        await this.loadUserTenants();
        if (sonuc.eklenen === 0 && sonuc.silinen === 0) this.bildir("Değişiklik yok");
        else this.bildir(`${sonuc.eklenen} yetki eklendi, ${sonuc.silinen} yetki kaldırıldı`);
      } catch (error) {
        this.bildir("Yetkiler kaydedilirken hata oluştu");
      } finally {
        this.saving = false;
      }
    },
    topluDialogAc() {
      this.topluKullanicilar = [];
      this.topluTenantlar = [];
      this.topluPazaryerleri = [];
      this.topluDialog = true;
    },
    async topluKaydet() {
      this.saving = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_API}/api/usertenants/toplu`, {
          method: "POST",
          headers: { "Content-Type": "application/json", ...this.yetkiBasligi() },
          body: JSON.stringify({
            userIds: this.topluKullanicilar,
            tenantIds: this.topluTenantlar,
            mpIds: this.topluPazaryerleri
          })
        });
        if (!response.ok) {
          this.bildir("Toplu yetki verilirken hata oluştu");
          return;
        }
        const sonuc = await response.json();
        this.topluDialog = false;
        await this.loadUserTenants();
        this.bildir(`${sonuc.eklenen} yetki verildi, ${sonuc.atlanan} tanesi zaten vardı`);
      } catch (error) {
        this.bildir("Toplu yetki verilirken hata oluştu");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.v-toolbar {
  margin-bottom: 20px;
}
.yt-durum {
  padding: 40px;
  text-align: center;
  color: #999;
}
.yt-satir {
  padding: 14px 18px;
  border-bottom: 1px solid #eee;
}
.yt-satir:last-child {
  border-bottom: none;
}
.yt-satir:hover {
  background: #fafafa;
}
.yt-ust {
  display: flex;
  align-items: center;
}
.yt-ad {
  font-size: 15px;
  font-weight: 600;
  color: #222;
}
.yt-tam {
  margin-left: 10px;
  font-size: 13px;
  color: #999;
}
.yt-sayi {
  font-size: 12px;
  color: #1976d2;
  background: #e3f2fd;
  padding: 3px 10px;
  border-radius: 11px;
  margin-right: 4px;
}
.yt-sayi.yt-sifir {
  color: #999;
  background: #f0f0f0;
}
.yt-alt {
  margin-top: 6px;
}
.yt-tenant {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  margin-top: 4px;
}
.yt-tenant-ad {
  min-width: 118px;
  font-size: 12px;
  color: #888;
}
.yt-rozet {
  display: inline-block;
  font-size: 12px;
  color: #444;
  background: #f2f2f2;
  border-radius: 3px;
  padding: 2px 8px;
  margin: 2px 4px 2px 0;
}
.yt-grup {
  margin-bottom: 18px;
}
.yt-grup-ust {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
  margin-bottom: 8px;
}
.yt-grup-ad {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  flex: 1;
}
.yt-hepsi {
  min-width: 0;
  font-size: 11px;
  margin: 0;
}
.yt-kutular {
  display: flex;
  flex-wrap: wrap;
}
.yt-kutu {
  display: flex;
  align-items: center;
  width: 50%;
  padding: 5px 0;
  cursor: pointer;
  font-size: 14px;
  color: #333;
}
.yt-kutu input {
  width: 16px;
  height: 16px;
  margin-right: 9px;
  cursor: pointer;
}
.yt-ozet {
  margin-top: 10px;
  padding: 10px 12px;
  background: #e3f2fd;
  border-radius: 4px;
  font-size: 14px;
  color: #1565c0;
}
.yt-ozet-bos {
  background: #f5f5f5;
  color: #888;
}
.yt-ozet-kucuk {
  font-size: 12px;
  color: #888;
  padding-left: 8px;
}
</style>
